module.exports = __webpack_public_path__ + "img/mem_coupon_font3.47577f10.jpg";